module.exports = __webpack_public_path__ + "static/media/trainer.75e06018.svg";